module.exports = __webpack_public_path__ + "static/media/Euro2020Final-1370.e5f29a0c.jpg";